import React from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import * as actions from '../actions/userprofileactions'



export default function ChangePassword() {
    const { register: registerChangePassword,    handleSubmit: handleSubmitChangePassword,    reset: resetChangePassword,
    watch: watchChangePassword, clearErrors, formState: { errors: errorsChangePassword } } = useForm();
    const state = useSelector(state => state.userProfileReducer);
    let updateUserProfile = state.updateUserProfile;
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const handleChangePassword = (e) => {
        const { name, value } = e.target;


        dispatch(actions.updateUserProfileState({ name, value }));

    }
    const handlePasswordMeterState = (e) => {
        dispatch(actions.showPasswordStrengthMeter());
    }
    const onSubmitChangePassword = async () => {

        let resp= await dispatch(actions.updateUserPassword()); //{
       if(resp){
        resetChangePassword();
            dispatch(actions.clearChangePasswordParams());
            document.getElementById('closeChangePasswordModal').click();
        }

            //navigate('/userprofilemi');
           // alert('Password Changed');

       // }
    }

    const onErrorChangePassword = (errorsChangePasswordn, e) => console.log(errorsChangePassword, e);
    const onResetChangePassword = (e) => {
        resetChangePassword();
        dispatch(actions.clearChangePasswordParams());
    }
    let OldPassword = <input className={errorsChangePassword.oldPassword ? 'form-control is-invalid' : 'form-control'}
        type="password" id="oldPassword" required=""
        placeholder="Enter Current Password"
        name='oldPassword'

        {...registerChangePassword("oldPassword", {
            required: true,
            minLength: 8,
            onChange: (e) => handleChangePassword(e)
        })}


    />
    let Newpassword = <input className={errorsChangePassword.newPassword ? 'form-control is-invalid' : 'form-control'}
        id="newPassword" required="" type="password"
        placeholder="Enter New Password"
        name='newPassword'

        {...registerChangePassword("newPassword", {
            required: true,
            minLength: 8,
            onChange: (e) => handleChangePassword(e)
        })}



    />
    let ConfirmPassword = <input className={errorsChangePassword.confirmPassword ? 'form-control is-invalid' : 'form-control'}

    type="password" id="confirmPassword" required=""
        placeholder="Confirm New Password Password"
        name='confirmPassword'
        {...registerChangePassword("confirmPassword",
            {
                required: true,
                minLength: 8,
                onChange: (e) => handleChangePassword(e)
            },)}

    />

    return (
        <form onSubmit={handleSubmitChangePassword(onSubmitChangePassword, onErrorChangePassword)}>
            <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true" >
                <div class="modal-dialog"  >
                    <div class="modal-content" >

                        <div class="modal-header">
                            <div className="ribbon-box">
                                <div className="ribbon ribbon-primary float-start"><i className="mdi mdi-account-circle-outline me-1"></i>Change Password</div></div>
                            <button type="button" class="btn-close btn-danger" id="closeChangePasswordModal" data-bs-container="#tooltip-container2" data-bs-toggle="tooltip" data-bs-placement="bottom"
                                title="Cancel" data-bs-dismiss="modal" aria-hidden="true" onClick={() => onResetChangePassword()}></button>
                        </div>
                        <div class="modal-body">
                            <div className="row g-2">
                                <div className="mb-12 col-md-12">
                                    <label for="inputPassword4" className="form-label"> <span style={{ color: 'red' }}>*</span> Old Passowrd </label>
                                    {OldPassword}
                                    {errorsChangePassword.oldPassword && <span style={{ color: 'red' }}> Minimum 8 Characters Required.</span>}

                                </div>
                            </div>
                            <div className="row g-2">
                                <div className="mb-12 col-md-12">
                                    <label for="inputPassword4" className="form-label"><span style={{ color: 'red' }}>*</span> New Password </label>
                                    {Newpassword}
                                    {errorsChangePassword.newPassword && <span style={{ color: 'red' }}> Minimum 8 Characters Required.</span>}

                                </div>
                            </div>
                            <div className="row g-2">
                                <div className="mb-12 col-md-12">
                                    <label for="inputPassword4" className="form-label"><span style={{ color: 'red' }}>*</span> Confirm Password</label>
                                    {ConfirmPassword}
                                    {errorsChangePassword.confirmPassword && <span style={{ color: 'red' }}> Minimum 8 Characters Required.</span>}<br></br>
                                    {updateUserProfile.newPassword !== updateUserProfile.confirmPassword && <span style={{ color: 'red' }}>Password Does not match</span>}
                                </div></div>

                        </div>
                        <div className="d-grid mb-0 text-center">
                                    <span style={{ color: "red" }}>  {updateUserProfile.updatePasswordMessage && updateUserProfile.updatePasswordMessage}</span>
                                </div>

                        <div class="modal-footer">
                            <button type="submit" className="btn btn-warning float-end"
                                data-bs-container="#tooltip-container2" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Save" ><i className="mdi mdi-content-save-outline"></i>Update Password</button>
                        </div>
                    </div>
                </div>
            </div>

            <div>

            </div>
        </form >

    )
}